import { createApi } from "@reduxjs/toolkit/query/react";
import { getAxiosInstance } from "../../../api";

const axiosBaseQuery =
  () =>
  async ({ params, endpoint, method, body }) => {
    
    const api = await getAxiosInstance();
    const getParams = (key) => {
    
      if (params?.[key]) {
        return `${key}=${params[key]}&`;
      } else {
        return "";
      }
    };

    try {
      const response = await api[method](
        `${endpoint}?${getParams("start_date")}${getParams(
          "end_date"
        )}${getParams("filter")}${getParams("sort_by")}is_active=${
          params?.is_active ? params["is_active"] : 0
        }&sort_order=${
          params?.sort_order || "desc"
        }&per_page=${params?.per_page || "10"}&${getParams("search")}page=${
          params?.page || 1
        }`,
        body
      );

      return { data: response.data };
    } catch (axiosError) {
      let err = axiosError;

      return {
        data: err?.response?.data || err.message,
      };
    }
  };

export const profile = createApi({
  reducerPath: "profileApi",
  baseQuery: axiosBaseQuery(),
  tagTypes: ["profile"],
  endpoints: (builder) => ({
    getProfileData: builder.query({
      query: (values) => ({
        method: "get",
        params: values,
        endpoint: `/admin/profile`,
      }),
      providesTags: ["profile"],
    }),
    
    updateProfileData: builder.mutation({
      query: (body) => ({
        method: "post",
        body,
        endpoint: `/v1/admin/settings/update-company-deatils`,
      }),

      invalidatesTags: ["profile"],
    }),

    updatePassword: builder.mutation({
      query: (body) => ({
        method: "post",
        body,
        endpoint: `/v1/admin/reset-password`,
      }),

      invalidatesTags: ["profile"],
    }),
    
  }),
});

export const { useUpdateProfileDataMutation, useGetProfileDataQuery, useUpdatePasswordMutation } = profile;
